// Check First Requests
export const units = '/units';
export const employees = '/employees';
export const departments = '/departments';

export const issues = '/issues';
export const demoRentals = '/rentals/demo';
export const rentalCount = '/rentals/count';
export const clients = '/clients';
export const users = '/users';
export const clientUsers = '/client-users';
export const loginURL = '/auth/login';
export const magicLinkLoginURL = '/auth/magic-link';
export const signUpURL = '/auth/registration';
export const refreshTokenReq = '/auth/refresh';
export const emailVerificationURL = '/auth/email-verification';
export const resendVerificationURL = '/auth/resend-verification';
export const uploadFileURL = '/et-file-manager/upload-url';
export const fotrgetPasswordURL = '/auth/resetPassword';
export const updatePasswordURL = '/auth/password';

export const reports = 'reports';
export const tokens = 'tokens';
export const clientsConfigurations = '/configurations';
export const configurationKey = (key: string) => `/configurations/${key}`;
export const clientConfigurationKey = (clientId: number, key: string) =>
  `/clients/${clientId}/configurations/${key}`;
export const clientConfigurations = (clientId: number) =>
  `/clients/${clientId}/configurations`;

export const updateClientURL = (clientId: number) => `/clients/${clientId}`;

export const tokenInstructionEmail = (tokenId: number) =>
  `${tokens}/${tokenId}/tokenInstructionEmail`;

// API keys
export const clientApiKeys = (clientId: string) =>
  `/clients/${clientId}/api-keys`;

export const getPaymentPrices = `payment/prices`;

export const paymentSubscription = (priceId: string) =>
  `payment/prices/${priceId}/subscription-sessions`;

export const paymentSubscriptionDetails = (subscriptionId: string) =>
  `payment/subscriptions/${subscriptionId}`;

export const paymentPortalSessions = 'payment/portal-sessions';

export const clientActivitiesReq = '/clients-activities';

export const reportedChecklistItemsReq = (checklistItemId: number) =>
  `/checklist-items/${checklistItemId}/reported-items`;

export const unitsCountReq = `${units}/count`;

export const reportsCountReq = `${reports}/count`;

export const reportIssues = `/reports-issues`;

export const issueDetails = (id: number) => `/reports-issues/${id}`;

export const reportsSharingToken = (reportId: number) =>
  `${reports}/${reportId}/tokens`;

export const reportSignature = (reportId: number) =>
  `/reports/${reportId}/signatures`;

  export const webhooks = '/hooks';

  export const webhookDetails= (id: number) => `/hooks/${id}`;
